import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const PRODUCTIVITY_INFO_API_URL = "analysis/productivity/";
const PRODUCTIVITY_DRR_API_URL = "analysis/drr-projection/";
const CASE_DETAILS_API_URL = "analysis/case-details/";

export const fetchProductivity = createAsyncThunk(
  "analysis/fetchAnalysis",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      const trusts = state.trust.selected_trusts;
      const query = state.filters.query;

      if (!token) {
        return;
      }

      const queryParams = {};

      // Add selected trust IDs
      if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
        queryParams.portfolio_id = query?.trust_id?.join(",");
      }
      if (Array.isArray(query?.state) && query.state.length !== 0) {
        queryParams.state = query.state.join(",");
      }
      if (Array.isArray(query?.region) && query.region.length !== 0) {
        queryParams.region = query.region.join(",");
      }
      if (Array.isArray(query?.status) && query.status.length !== 0) {
        queryParams.status = query.status.join(",");
      }
      if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
        queryParams.date_to = query.date_to.join(",");
      }
      if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
        queryParams.date_from = query.date_from.join(",");
      }
      if (Array.isArray(query?.agency) && query.agency.length !== 0) {
        queryParams.agency = query.agency.join(",");
      }
      if (Array.isArray(query?.loan_type) && query.loan_type.length !== 0) {
        queryParams.loan_type = query.loan_type.join(",");
      }

      if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
        queryParams.team_member = query.team_member.join(",");
      }
      if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
        queryParams.team_leader = query.team_leader.join(",");
      }

      const response = await axios.get(PRODUCTIVITY_INFO_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch analysis"
      );
    }
  }
);

export const fetchProductivityDrrProjection = createAsyncThunk(
  "analysis/fetchDRR",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      const trusts = state.trust.selected_trusts;
      const query = state.filters.query;

      if (!token) {
        return;
      }

      const queryParams = {};
      const { team_member, team_leader } = params;

      // Add selected trust IDs
      if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
        queryParams.portfolio_id = query?.trust_id?.join(",");
      }
      if (Array.isArray(query?.state) && query.state.length !== 0) {
        queryParams.state = query.state.join(",");
      }
      if (Array.isArray(query?.region) && query.region.length !== 0) {
        queryParams.region = query.region.join(",");
      }
      if (Array.isArray(query?.status) && query.status.length !== 0) {
        queryParams.status = query.status.join(",");
      }
      if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
        queryParams.date_to = query.date_to.join(",");
      }
      if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
        queryParams.date_from = query.date_from.join(",");
      }
      if (Array.isArray(query?.agency) && query.agency.length !== 0) {
        queryParams.agency = query.agency.join(",");
      }
      if (Array.isArray(team_member) && team_member.length !== 0) {
        queryParams.team_member = team_member.join(",");
      }
      if (Array.isArray(team_leader) && team_leader.length !== 0) {
        queryParams.team_leader = team_leader.join(",");
      }
      if (Array.isArray(query?.loan_type) && query.loan_type.length !== 0) {
        queryParams.loan_type = query.loan_type.join(",");
      }

      if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
        queryParams.team_member = query.team_member.join(",");
      }
      if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
        queryParams.team_leader = query.team_leader.join(",");
      }

      const response = await axios.get(PRODUCTIVITY_DRR_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch analysis"
      );
    }
  }
);

// 3. Case Details
export const fetchCaseDetails = createAsyncThunk(
  "analysis/fetchCaseDetails",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      const query = state.filters.query;

      if (!token) return;

      const queryParams = {};

      if (params.page) {
        queryParams.page = params.page;
      }
      if (params.page_size) {
        queryParams.page_size = params.page_size;
      }

      if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
        queryParams.portfolio_id = query?.trust_id?.join(",");
      }

      if (Array.isArray(query?.state) && query.state.length !== 0) {
        queryParams.state = query.state.join(",");
      }
      if (Array.isArray(query?.region) && query.region.length !== 0) {
        queryParams.region = query.region.join(",");
      }
      if (Array.isArray(query?.status) && query.status.length !== 0) {
        queryParams.status = query.status.join(",");
      }
      if (query?.date_to) {
        queryParams.date_to = query.date_to;
      }
      if (query?.date_from) {
        queryParams.date_from = query.date_from;
      }
      if (Array.isArray(query?.agency) && query.agency.length !== 0) {
        queryParams.agency = query.agency.join(",");
      }
      if (Array.isArray(query?.loan_type) && query.loan_type.length !== 0) {
        queryParams.loan_type = query.loan_type.join(",");
      }

      const response = await axios.get(CASE_DETAILS_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch case details"
      );
    }
  }
);

// --------------------------- end thunk ---------------
const initialState = {
  productivity: [],
  loading: false,
  error: null,
  drrProjection: [],
  drrProjectionLoading: false,
  caseDetails: [],
  caseDetailsLoading: false,
};

const productivitySlice = createSlice({
  name: "productivity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductivity.fulfilled, (state, action) => {
        state.loading = false;
        state.productivity = action.payload;
      })

      .addCase(fetchProductivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
        state.productivity = {};
        state.error = null;
      })

      .addCase(fetchProductivityDrrProjection.pending, (state) => {
        state.drrProjectionLoading = true;
      })
      .addCase(fetchProductivityDrrProjection.fulfilled, (state, action) => {
        state.drrProjectionLoading = false;
        state.drrProjection = action.payload;
      })

      .addCase(fetchProductivityDrrProjection.rejected, (state, action) => {
        state.drrProjectionLoading = false;
        state.drrProjection = [];
      })

      .addCase(fetchCaseDetails.pending, (state) => {
        state.caseDetailsLoading = true;
      })
      .addCase(fetchCaseDetails.fulfilled, (state, action) => {
        state.caseDetailsLoading = false;
        state.caseDetails = action.payload;
      })
      .addCase(fetchCaseDetails.rejected, (state) => {
        state.caseDetailsLoading = false;
        state.caseDetails = [];
      });
  },
});

export const { clearAnalysis } = productivitySlice.actions;
export default productivitySlice.reducer;
